import React from 'react'
import { Container, Paper, styled } from '@mui/material'
import cx from 'classnames'
import { PropTypes } from 'prop-types'

import TitleBar from './TitleBar'

const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.white,
  boxShadow: 'none',
  margin: `0 auto`,
  overflow: 'hidden',
  '&.MuiPaper-a4': {
    padding: '.5cm',
    width: '21cm',
    height: '29.7cm',
  },
}))

function Page({ children, size, orientation, digitalCertificate }) {
  const isRefactory = digitalCertificate?.basicData?.isRefactory ?? false
  return (
    <StyledPaper className={cx(`MuiPaper-${size}`, `MuiPaper-${orientation}`)}>
      <TitleBar isRefactory={isRefactory} />
      <Container maxWidth="false" sx={{ p: 3 }}>
        {children}
      </Container>
    </StyledPaper>
  )
}
Page.propTypes = {
  children: PropTypes.node,
  orientation: PropTypes.oneOf(['landscape', 'portrait']),
  size: PropTypes.oneOf(['a0', 'a1', 'a2', 'a3', 'a4', 'a5']),
  digitalCertificate: PropTypes.object,
}
Page.defaultProps = {
  children: null,
  orientation: 'portrait',
  size: 'a4',
  digitalCertificate: null,
}
export default Page
